import {
  Component,
  OnInit,
  AfterViewInit,
  ViewContainerRef,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Input,
  SimpleChanges,
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { HelperService } from "app/helpers/helper.service";

@Component({
  selector: "app-party-person-empty-card",
  templateUrl: "./party-person-empty-card.component.html",
  styleUrls: ["./party-person-empty-card.component.scss"],
  animations: fuseAnimations,
})
export class PartyPersonEmptyCardComponent implements OnInit, AfterViewInit {
  private isViewInit = false;

  public callback = function () {
    //Card Click Callback
  };

  public afterViewInit = () => {};

  constructor(private cdr: ChangeDetectorRef, private helper: HelperService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.afterViewInit();
    this.isViewInit = true;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onCardClick(): void {
    this.callback();
  }

  setAsPlaceHolder(): void {}

  addExtraContainerElements(html: string): void {}

  ngOnChanges(changes: SimpleChanges): void {}
}
